import {gql, useMutation} from "@apollo/client";
import {Competence, MutationAddCompetenceArgs, MutationUpdateCompetenceArgs} from "../../schema";

export function useAddCompetenceMutation() {
  return useMutation<{competence: Competence}, MutationAddCompetenceArgs>(addCompetenceMutation);
}

export function useUpdateCompetenceMutation() {
  return useMutation<{competence: Competence}, MutationUpdateCompetenceArgs>(updateCompetenceMutation);
}

const addCompetenceMutation = gql`
  mutation addCompetenceMutation($name: String!, $description: String, $indicators: [String!]) {
    competence: addCompetence(name: $name, description: $description, indicators: $indicators) {
      id
      name
      description
      indicators
    }
  }
`;

const updateCompetenceMutation = gql`
  mutation updateCompetenceMutation($id: ID!, $name: String!, $description: String, $indicators: [String!]) {
    competence: updateCompetence(id: $id, name: $name, description: $description, indicators: $indicators) {
      id
      name
      description
      indicators
    }
  }
`;
